// import { getFollowBrands } from "@/api/home";
import BottomNotice from "@/components/bottom-notice";
import CouponNotice from "@/components/coupon-notice";
import DailyRewardNotice from "@/components/daily-reward-notice";
import MarketingPopup from "@/components/marketing-popup";
import { VcSceneProvider } from "@/components/product-waterfall";
import RedPacketNotice from "@/components/red-packet-notice";
import ToExChangeTip from "@/pages/rewardCenter/components/ToExchangeTip/ToExchangeTip";
import { useCommonContext } from "@/utils/context/common";
import useSkin from "@/utils/hooks/useSkin";
import Track from "@/utils/track";
// import useNavigation from "@/utils/useNavigate";
import { VideoCardScene } from "@akc/biz-api";
import { TrackDataContext } from "@akc/mx-taro-h5-components";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useActivate } from "react-activation";
import { useSearchParams } from "react-router-dom";
import ActivityList from "./components/ActivityList";
import CategoryTab from "./components/CategoryTab";
import CouponWindow from "./components/coupon-pop/CouponWindow";
import ModeTab from "./components/ModeTab";
import CouponBoardV1 from "./components/new-person/CouponBoardV1";
import ProductFeedList from "./components/ProductFeedList/ProductFeedList";
import ProductWaterfall from "./components/ProductList";
import ResourceList from "./components/ResourceList";
import SearchBar from "./components/SearchBar";
import useShopInfo from "./hooks/useShopInfo";
import styles from "./index.module.less";
const track = Track();
/**
 * 首页,useSearchParams获取url参数包括:
 * previewRsc: 是否预览资源位,1是0否，空也是否
 * activityTagName: 初始类目名称，用来匹配初始高亮类目
 * @returns 
 */
const Home: React.FC = () => {
  const { currentRole, setCategorySkin, getSkinByKey, activityTagNo, setActivityTagNo, skin } =
    useCommonContext();

  // 页面query参数
  const [search] = useSearchParams();
  const previewRsc = search.get("previewRsc") || "0";
  const previousPageName = search.get("page_name") || "";
  // 当前高亮类目下标
  const activityTagIndex = useRef<number>(0);
  const [tabName, setTabName] = useState<string>();
  const [hasTopNotice, setHasTopNotice] = useState<boolean>(false);
  const [mode, setMode] = useState<"activity" | "product">("activity");

  // const [followBrands, setFollowBrands] = useState<any[]>([]);
  const [showTabPop, setShowTabPop] = useState<boolean>(false);
  const timer = useRef<any>(null);
  const containerDom = useRef<HTMLDivElement>(null);
  // const { navigate2H5 } = useNavigation();
  const { shopName } = useShopInfo();
  // 首页灰度版本
  const [homeGrayVersion, setHomeGrayVersion] = useState<string>("");
  useSkin();

  // const handleClickFavoriteBrand = ({ brandNo }) => {
  //   navigate2H5("/#/my-focus", {
  //     query: `brandNo=${brandNo}&type=0`,
  //   });
  // };

  const onShowTabPop = isShow => {
    if (isShow) {
      clearTimeout(timer.current);
      setShowTabPop(isShow);
    } else {
      timer.current = setTimeout(() => {
        setShowTabPop(isShow);
      }, 1000);
    }
  };
  // 埋点上下文数据设置
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { setTrackData } = useContext(TrackDataContext);

  useEffect(() => {
    document.title = shopName;
  }, [shopName]);

  useEffect(() => {
    setTrackData({
      page_name: "首页",
      tab_name: tabName,
    });
  }, [tabName]);

  useEffect(() => {
    const shopId = localStorage.getItem("shopId");
    if (!shopId) {
      return;
    }
    // getFollowBrands().then(data => {
    //   setFollowBrands(data);
    // });
    document.body.style.overflow = "unset";

    track.pageView("首页", {
      page_name: "首页",
      domain: "首页",
    });
  }, []);

  useEffect(() => {
    if (activityTagNo && activityTagNo !== "10") {
      setMode("activity");
    }
  }, [activityTagNo]);

  useActivate(() => {
    document.title = shopName;
  });

  useEffect(() => {
    // 设置皮肤
    setCategorySkin(activityTagNo);
  }, [activityTagNo, skin.hasNewSkin]);


  // 档期或商品瀑布流片段
  const getFeedListFragment = () => {
    // 尚未查到灰度版本
    if (homeGrayVersion === "") {
      return null;
    }
    // 命中灰度
    if (homeGrayVersion === "1") {
      // C用户展示新商品feed流
      if (currentRole === "C") {
        return (
          <VcSceneProvider value={VideoCardScene.videoCardHomePage}>
            <ProductFeedList
              pageId="H5_Feed"
              activityTagIndex={activityTagIndex.current}
              activityTagNo={activityTagNo}
              activityTagName={tabName}
              previewRsc={previewRsc}
              previousPageName={previousPageName}
            />
          </VcSceneProvider>
        );
      }
      // B用户展示档期列表
      return (
        <ActivityList
          activityTagIndex={activityTagIndex.current}
          activityTagNo={activityTagNo}
          activityTagName={tabName}
          pageId="H5_ScheduleList"
          homeGrayVersion={homeGrayVersion}
          previousPageName={previousPageName}
        />
      );
    }
    // 未命中灰度，展示旧版本
    return (
      <>
        {/* 今天大牌、甄选精品tabs */}
        {currentRole === "C" && activityTagNo === "10" && (
          <div className={styles.modeTabWrap}>
            <ModeTab mode={mode} setMode={setMode} />
          </div>
        )}
        {/* 商品feed流 */}
        <VcSceneProvider value={VideoCardScene.videoCardHomePage}>
          {mode === "product" && activityTagNo === "10" && <ProductWaterfall pageId="H5_Feed" />}
        </VcSceneProvider>

        {/* 档期列表 */}
        {mode === "activity" && (
          <ActivityList
            activityTagIndex={activityTagIndex.current}
            activityTagNo={activityTagNo}
            activityTagName={tabName}
            pageId="H5_ScheduleList"
            homeGrayVersion={homeGrayVersion}
            previousPageName={previousPageName}
          />
        )}
      </>
    );
  };

  return (
    <div
      ref={containerDom}
      className={styles.container}
      style={getSkinByKey("HOME_CONTAINER")}
      id="homeContainer">
      {/* 日日奖红包到期提醒组件 */}
      <RedPacketNotice topOffset={-2} />

      {/* 顶部吸顶提示栏、搜索栏、类目tabs（全部类目下，navHeaderBgImg优先级最高，可以覆盖HOME_HEADER中的背景图） */}
      <div
        className={styles.headerWrap}
        style={{
          ...getSkinByKey("HOME_HEADER"),
          zIndex: showTabPop ? "11001" : "1000",
          ...(skin?.pageGlobalSkinVO?.navHeaderBgImg && activityTagNo === "10"
            ? {
                background: `url(${skin?.pageGlobalSkinVO?.navHeaderBgImg})  no-repeat center`,
                backgroundSize: "cover",
              }
            : {}),
        }}>
        {/* 吸顶优惠券提示 */}
        <CouponNotice afterShow={val => setHasTopNotice(val)} />
        {/* 旧版搜索栏（类目上方） */}
        {homeGrayVersion === "0" && <SearchBar homeGrayVersion={homeGrayVersion} />}
        {/* 类目tabs */}
        <CategoryTab
          setActivityTagInfo={info => {
            setActivityTagNo(info.tagNo);
            setTabName(info.tagName);
            activityTagIndex.current = info.index;
          }}
          containerDom={containerDom}
          hasTopNotice={hasTopNotice}
          onShowTabPop={onShowTabPop}
          setHomeGrayVersion={setHomeGrayVersion}
        />
        {/* 新版搜索栏（类目下方） */}
        {homeGrayVersion === "1" && <SearchBar homeGrayVersion={homeGrayVersion} />}
      </div>

      {activityTagNo && (
        <>
          {/* 资源位列表 */}
          <div className={styles.resourceContainer}>
            <ToExChangeTip showClose={true} />
            {/* 其他资源位 */}
            <ResourceList
              activityTagNo={activityTagNo}
              activityTagIndex={activityTagIndex.current}
            />
            {/* 新人专享券 */}
            {activityTagNo === "10" && (
              <>
                <CouponBoardV1 />
                {/* <IntegralCard /> */}
                {/* <HomeMyFavoriteBrandComp
                  brandList={followBrands}
                  onDetailAction={handleClickFavoriteBrand}
                /> */}
              </>
            )}
          </div>

          {/* 档期或商品feed流 */}
          <div className={styles.cardContainer}>{getFeedListFragment()}</div>
        </>
      )}

      {/* 漂浮在底部的通告栏 */}
      <BottomNotice />

      <CouponWindow />
      {/* 用户中奖通知 */}
      <DailyRewardNotice topOffset={-2} />
      {/* 营销弹框 */}
      <MarketingPopup serverCode="mall_index" />
    </div>
  );
};

export default Home;
